<template>
  <MainSiteLayout v-bind="{ content }">
    <HeroWithTextOnly :breadcrumbs="breadcrumbs" :content="heroContent" />
    <Container tagName="section" class="bodyContainer">
      <DefaultBlockContent v-if="content.body" :blocks="content.body" class="body" />
    </Container>
    <FooterCta v-if="content.footerCta" :content="content.footerCta" />
  </MainSiteLayout>
</template>

<script>
export const contentQuery = `
  *[_id == $pageId][0]{
    locale,
    heading,
    subtitle,
    body,
    footerCta,
  }
`
</script>

<script setup>
import { provide } from 'vue'

import MainSiteLayout from '../../layouts/MainSiteLayout.vue'
import DefaultBlockContent from '../elems/DefaultBlockContent.vue'
import FooterCta from '../headerFooterSections/FooterCta.vue'
import HeroWithTextOnly from '../headerFooterSections/HeroWithTextOnly.vue'

const { breadcrumbs, content } = defineProps({
  breadcrumbs: Array,
  content: Object,
})

provide('locale', content.locale)

const heroContent = { heading: content.heading, subtitle: content.subtitle }
</script>


<style scoped>

.bodyContainer {
  padding-top: var(--spacing-15);
  padding-bottom: var(--spacing-15);
}

.body {
  font-size: var(--font-size-3);
  line-height: 1.7;
}

.body:deep(h2) {
  font-size: var(--font-size-8);
}

.body:deep(h3) {
  font-size: var(--font-size-7);
}

.body:deep(h4) {
  font-size: var(--font-size-6);
}

.body:deep(h5) {
  font-size: var(--font-size-5);
}

.body:deep(h6) {
  font-size: var(--font-size-4);
}

@media (--screen-lg) {

  .body:deep(h2) {
    font-size: var(--font-size-10);
  }

  .body:deep(h3) {
    font-size: var(--font-size-8);
  }

  .body:deep(h4) {
    font-size: var(--font-size-7);
  }

  .body:deep(h5) {
    font-size: var(--font-size-5);
  }

  .body:deep(h6) {
    font-size: var(--font-size-4);
  }
}
</style>
